import React, { Component } from 'react';
import { Col, Card, Button } from 'react-bootstrap';
// import { Row, Badge, Offcanvas, ListGroup } from 'react-bootstrap';
import { AgGridReact } from 'ag-grid-react';

import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import "flag-icons/css/flag-icons.min.css";
import '../components/leads.css';

import SplitPane from 'split-pane-react';
import 'split-pane-react/esm/themes/default.css';
import axios from "axios";
const appInfo = require("../../package.json");

const GROUP_BY_CATEGORY = 'category_en';
const GROUP_BY_STATE = 'state';

const defaultColDef = {
    filter: true,
    sortable: true,
    resizable: true,
    enableRowGroup: true,
    menuTabs: ['filterMenuTab', 'generalMenuTab', 'columnsMenuTab'],
    filterParams: {
      buttons: ["reset"],
      closeOnApply: true,
    },
};

const autoGroupColumnDef = {
  pinned: 'left', // Pin the group column to the left
}

const defaultSideBar = {
  toolPanels: [
    {
      id: 'filters',
      labelDefault: 'Filters',
      labelKey: 'filters',
      iconKey: 'filter',
      toolPanel: 'agFiltersToolPanel',
      toolPanelParams: {
        suppressExpandAll: true,
        suppressFilterSearch: true,
      }
    },
    {
      id: 'columns',
      labelDefault: 'Columns',
      labelKey: 'columns',
      iconKey: 'column',
      toolPanel: 'agColumnsToolPanel',
      toolPanelParams: {
        suppressExpandAll: true,
        suppressFilterSearch: true,
      },
    },
  ],
};

const rowSelection = 'single';
const rowGroupPanelShow = 'onlyWhenGrouping';
const rowModelType = 'serverSide';
const cacheBlockSize = 100;

const pastelBackgrounds = ['#008FFB','#00E396','#FEB019','#FF4560','#775DD0','#3f51b5','#03a9f4','#4caf50','#f9ce1d','#FF9800','#A300D6','#7D02EB','#5653FE','#2983FF','#00B1F2'];

class MCatalog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            groupByCategory: true,
            isGridView: false,
            gridApi: null,
            rowData: [],
            columnDefs: [],
            selectedData: [],
            selectedUtld: '',
            updatingRowData: false,
            gsplit: [`0%`, 'auto'],
            cards: [],
            selectedCard: 0,
            lastVisibleCard: 0,
            filterMode: 0,
            // shoppingCart: [],
            // showCart: false,
            // userPricing: ((this.props.loggedInUserPlan.usercountry === 'IN') ? {locale: 'en-IN', currency: 'INR', cost: 0.05} : {locale: 'en-US', currency: 'USD', cost: 0.01}),
        }

        this.onGridReady = this.onGridReady.bind(this);
        this.getRows = this.getRows.bind(this);
        this.getChildCount = this.getChildCount.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.onModelUpdated = this.onModelUpdated.bind(this);
        this.onFirstDataRendered = this.onFirstDataRendered.bind(this);
        this.groupCountComparator = this.groupCountComparator.bind(this);
        this.onStoreRefreshed = this.onStoreRefreshed.bind(this);
        this.intRenderer = this.intRenderer.bind(this);
        this.toggleGroup = this.toggleGroup.bind(this);
        this.toggleView = this.toggleView.bind(this);
        this.refreshCards = this.refreshCards.bind(this);
        this.cardSelectionChanged = this.cardSelectionChanged.bind(this);
        this.applyFilter = this.applyFilter.bind(this);
        this.handleCardsScroll = this.handleCardsScroll.bind(this);
        this.agRequestRef = React.createRef();
        this.switchToList = this.switchToList.bind(this);
        this.exportData = this.exportData.bind(this);
        // this.addToCart = this.addToCart.bind(this);
        // this.deleteFromCart = this.deleteFromCart.bind(this);
        // this.isItemInCart = this.isItemInCart.bind(this);
    };

    switchToList(e) {
      const groupByCategory = this.state.groupByCategory;
      const category = e.currentTarget.dataset.category;
      const state = e.currentTarget.dataset.state; 
      this.props.stl({groupByCategory, category, state});
    }
 
    handleCardsScroll(e) {
      const cardsList = e.currentTarget;
      const top = (cardsList.scrollTop === 0);
      const bottom = (Math.abs(cardsList.scrollHeight - (cardsList.scrollTop + cardsList.clientHeight)) <= 5);
      if (top) {
        // this.state.gridApi?.ensureIndexVisible(0, 'top')
      } else if (bottom) {
        const index = this.state.cards.length;
        this.state.gridApi?.ensureIndexVisible(index, 'bottom');
        const lastVisibleIndex = Math.max(0, index - 1);
        const lastVisibleCard = this.state.cards[lastVisibleIndex].id;
        this.setState({ lastVisibleCard: lastVisibleCard });
      } else {
        this.setState({ lastVisibleCard: 0 });
      }
    }

    intRenderer (params) {
      return ((params.value && params.value !== '') ? <span>{parseInt(params.value).toLocaleString()}</span> : '')
    }

    fetchData = async() => {
      if (!this.state.updatingRowData) {
        this.setState({ updatingRowData: true });
        this.props.urd(true);

        this.state.gridApi?.refreshServerSide({purge: true});
      }
    }

    // Custom comparator function to sort groups by group counts
    groupCountComparator(valueA, valueB, nodeA, nodeB, isInverted) {
      // Get the group counts for the two groups
      const countA = nodeA ? nodeA.allChildrenCount : valueA; // Number of children in group A
      const countB = nodeB ? nodeB.allChildrenCount : valueB; // Number of children in group B

      // Compare the counts and return the result
      if (countA < countB) {
        return -1;
      } else if (countA > countB) {
        return 1;
      } else {
        return 0;
      }
    }

    onGridReady(params) {
        this.setState({
          gridApi: params.api,
        })
        params.api.setServerSideDatasource({getRows: this.getRows});
      }

    getRows(params) {
      const serverURL = `/api/getagmegacatalog/`;
      const isUserCategoryGroup = this.props.isucg;
      const selectedCategoryGroup = this.props.categorygroup?.value ?? '';
      const filterMultipleCategories = this.props.multipleCategories ?? '';
      const selectedCategory = this.props.category ?? '';
      const selectedCountry = this.props.country ?? '';
      const selectedState = `'${this.props.state ?? ''}'`;
      const selectedGroup = this.state.groupByCategory ? GROUP_BY_CATEGORY : GROUP_BY_STATE;
      const loggedInUserId= this.props.loggedInUserId ?? 0;

      this.agRequestRef.current = params.request;
      this.setState({ updatingRowData: true });
      this.props.urd(true);
      fetch(serverURL, {
        method: 'post',
        body: JSON.stringify({ ...params.request, selectedGroup, isUserCategoryGroup, selectedCategoryGroup, filterMultipleCategories, selectedCategory, selectedCountry, selectedState, loggedInUserId}),
        headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
      })
      .then(httpResponse => httpResponse.json())
      .then(response => {
        params.successCallback(response.rows, response.lastRow);
        if(response.appversion && response.appversion!==appInfo.version){
                  window.location.reload()
        }
        this.setState({ updatingRowData: false });
        this.props.rcu(response.totals.Totals)
        this.props.urd(false);
      })
      .catch(error => {
        console.error(error);
        params.failCallback();
      })
    }

    getChildCount(data) {
      return data ? data.childCount : undefined
    }
    
    onSelectionChanged() {
      if (this.state.isGridView) {
        const data = this.state.gridApi.getSelectedRows();
        this.setState({
            selectedData: data,
            selectedUtld: data.utld
        })
        this.props.data(data);
      }
    }

    onModelUpdated = (params) => {
      this.setState({ updatingRowData: false });
      this.props.urd(false);
      this.refreshCards();
    }

    onStoreRefreshed = (params) => {
      this.setState({ updatingRowData: false });
      this.props.urd(false);
    }

  onFirstDataRendered = (params) => {
    var cols = [
      { field: 'category_en', headerName: 'Category', filter: 'agTextColumnFilter', pinned: 'left' },
      { field: 'Total_Leads', headerName: 'Businesses', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Branches', headerName: 'Branches', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Addresses', headerName: 'Addresses', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Websites', headerName: 'Websites', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Phone_Numbers', headerName: 'Phone Numbers', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Emails', headerName: 'Emails', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'People', headerName: 'People', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'contactformcount', headerName: 'Contact Forms', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'contactformnccount', headerName: 'Contact Form No Captcha', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'contacturlcount', headerName: 'Contact Urls', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'abouturlcount', headerName: 'About URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'leadershipurlcount', headerName: 'Leadership URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'careersurlcount', headerName: 'Career URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'investorurlcount', headerName: 'Investor URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'carturlcount', headerName: 'Cart URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'producturlcount', headerName: 'Product URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'mobileappscount', headerName: 'Mobile App Presence', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'facebookurlcount', headerName: 'Facebook URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'twitterurlcount', headerName: 'Twitter URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'instagramurlcount', headerName: 'Instagram URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'linkedinurlcount', headerName: 'Linkedin URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'youtubeurlcount', headerName: 'Youtube URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'pinteresturlcount', headerName: 'Pinterest URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'whatsappurlcount', headerName: 'Whatsapp URLs', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'High_Presence', headerName: 'High_Presence', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Medium_Presence', headerName: 'Medium_Presence', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Low_Presence', headerName: 'Low_Presence', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'None_Presence', headerName: 'None_Presence', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'High_Reputation', headerName: 'High_Reputation', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Medium_Reputation', headerName: 'Medium_Reputation', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'Low_Reputation', headerName: 'Low_Reputation', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
      { field: 'None_Reputation', headerName: 'None_Reputation', filter: 'agNumberColumnFilter', cellRenderer: this.intRenderer, cellStyle: { textAlign: 'center' } },
    ];
    this.setState({ columnDefs: cols })
  }

  toggleGroup(data) {
    this.setState({groupByCategory: data});

    var cols = this.state.columnDefs; 
    if (this.state.columnDefs.length > 0) {
      if (data) {
        cols[0].field = 'category_en';
        cols[0].headerName = 'Category';
        cols[0].cellStyle = undefined;
      } else {
        cols[0].field = 'state';
        cols[0].headerName = 'State/Territory';
        cols[0].cellStyle = { textAlign: 'center' };
      } 
      this.setState({ columnDefs: cols});
    } 
    this.state.gridApi?.setColumnDefs(cols);

    this.refreshCards();
  } 

  toggleView(currentView) {
    this.setState({
      isGridView: currentView,
      gsplit: currentView ? ["100%", 'auto'] : ["0%", 'auto']
    })
    this.refreshCards();
  }

    refreshCards() {
      var cards = [];
      this.state.gridApi && this.state.gridApi.forEachNode((node, index) => {if ((!node.group) && (node.data)) cards.push(node.data)});
        this.setState({cards: cards});
        this.props.data([]);
      
      if (cards.length > 0) { 
        const selCard = Math.max(cards.findIndex(row => (row.utld === this.state.selectedUtld)), 0);
        const selData = cards[selCard];
        this.setState({
          selectedCard: selCard,
          selectedData: selData,
          selectedUtld: selData.utld
        });
        this.props.data(selData);
      }

      setTimeout(() => {
        const card = document.getElementById(`lead-${this.state.lastVisibleCard}`);
        card?.scrollIntoView(false);
      }, 50)
    }

    
    cardSelectionChanged(rowid) {
      
      const data = this.state.cards[rowid];
      this.setState({
        selectedData: data,
        selectedUtld: data.utld,
        selectedCard: rowid,
        lastVisibleCard: rowid,
      })
      this.props.data(data);

    }

    applyFilter(filterValues) {
      this.state.gridApi && this.state.gridApi.setFilterModel(filterValues);
      this.refreshCards();
    }

    exportData = async () => {
      this.props.passExportingData(true)

      const serverURL = `/api/exportagmegacatalog/`;
      const isUserCategoryGroup = this.props.isucg;
      const selectedCategoryGroup = this.props.categorygroup?.value ?? '';
      const selectedCategory = this.props.category ?? '';
      const selectedCountry = this.props.country ?? '';
      const selectedState = `'${this.props.state ?? ''}'`;
      const selectedGroup = this.state.groupByCategory ? GROUP_BY_CATEGORY : GROUP_BY_STATE;
      const filterMultipleCategories = this.props.multipleCategories ?? '';
      const userid = this.props.loggedInUserId ?? 0;
      fetch(serverURL, {
        method: 'post',
        body: JSON.stringify({ ...this.agRequestRef.current, userid, selectedGroup, isUserCategoryGroup, selectedCategoryGroup, filterMultipleCategories, selectedCategory, selectedCountry, selectedState}),
        headers: { "Content-Type": "application/json; charset=utf-8","Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}`}
      })
      .then(response => {
        response.blob().then(blob => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = `export-${Math.round(Math.random()*1000)}.xlsx`;
          a.click();
          a.remove();

          this.props.passExportingData(false)
        })
      })
      .catch(error => {
        console.error(error);
        this.props.passExportingData(false)
      })
    }

    state = {
      categoryImagesState: { data: "", loading: true, error: null }
    };    

    componentDidMount() {
      axios
        .get("/peferences") // your API endpoint
        .then((response) => {
          this.setState({
            categoryImagesState: {
              data: response.data.category_images_url,
              loading: false,
              error: null
            }
          });
        })
        .catch((error) => {
          this.setState({
            categoryImagesState: { data: "", loading: false, error }
          });
        });
    }

    getCategoryImageUrl(categoryName) {
      if (!categoryName) return "";
      let fileName = categoryName.trim().toLowerCase();
      fileName = fileName.replace(/&/g, "n");
      fileName = fileName.replace(/\//g, "or");
      fileName = fileName.replace(/\s+/g, "_");
      fileName += ".webp";
      const baseUrl = `${this.state.categoryImagesState.data}images/`;
      return `${baseUrl}${fileName}`;
    }
    
    /*
    addToCart(e) {
      const eDataValue = e.currentTarget.dataset.value;
      const eDataAmount = e.currentTarget.dataset.amount;

      let cartItem = {"type": "", "value": "", "amount": 0}
      cartItem.type = this.state.groupByCategory ? GROUP_BY_CATEGORY : GROUP_BY_STATE;
      cartItem.value = eDataValue;
      cartItem.amount = eDataAmount;

      let cartItems = this.state.shoppingCart;
      if (!cartItems.some(item => ((item.type === cartItem.type) && (item.value === cartItem.value)))) {
        cartItems.push(cartItem);
        this.setState({shoppingCart: cartItems});
      }
    }

    deleteFromCart(e) {
      const eDataType = e.currentTarget.dataset.type;
      const eDataValue = e.currentTarget.dataset.value;

      let cartItems = this.state.shoppingCart.filter(item => !((item.type === eDataType) && (item.value === eDataValue)));
      this.setState({shoppingCart: cartItems});
    }

    isItemInCart(category, state) {
      const eDataType = this.state.groupByCategory ? GROUP_BY_CATEGORY : GROUP_BY_STATE;
      const eDataValue = this.state.groupByCategory ? category : state;
      return this.state.shoppingCart.some(item => ((item.type === eDataType) && (item.value === eDataValue)))
    }
    */
    render () {
      const getSocialCount = (row) => {
        var result = 0;

        try {
          const socialCount = parseInt(row.facebookurlcount) +
                        parseInt(row.twitterurlcount) +
                        parseInt(row.linkedinurlcount) +
                        parseInt(row.instagramurlcount) +
                        parseInt(row.youtubeurlcount) +
                        parseInt(row.pinteresturlcount);
          if (socialCount >= 0) {
            result = socialCount
          }
        } catch {
          // do nothing
        }

        return result
      }
      
    return (
    <React.Fragment>
      <SplitPane split="horizontal" allowResize={false} sizes={this.state.gsplit} resizerSize={5} onChange={(data) => this.setState({gsplit: data})}>
        <div className="ag-theme-balham" style={{height: '100%'}}>
          <AgGridReact 
            columnDefs={this.state.columnDefs}
            defaultColDef={defaultColDef}
            autoGroupColumnDef={autoGroupColumnDef}
            sideBar={defaultSideBar}
            suppressContextMenu={true}
            animateRows={true}
            rowMultiSelectWithClick={false}
            rowSelection={rowSelection}
            rowGroupPanelShow={rowGroupPanelShow}
            onGridReady={this.onGridReady}
            onGridRefresh={this.onGridRefresh}
            onSelectionChanged={this.onSelectionChanged}
            onRowDataUpdated={this.onRowDataUpdated}
            onModelUpdated={this.onModelUpdated}
            onFirstDataRendered={this.onFirstDataRendered}
            onStoreRefreshed={this.onStoreRefreshed}
            rowModelType={rowModelType}
            getChildCount={this.getChildCount}
            cacheBlockSize={cacheBlockSize}
            alwaysShowHorizontalScroll={false}
            alwaysShowVerticalScroll={false}
          ></AgGridReact>
        </div>
        {this.state.cards ? (
        <div className="m-2" style={{maxHeight: "99%", display: 'grid', overflowX: 'hidden', overflowY: 'auto', gap: '4px', gridTemplateColumns: 'repeat(auto-fill, minmax(275px, 1fr))'}} onScroll={this.handleCardsScroll}>
          <div className={`w-100 justify-content-center ${((this.state.updatingRowData) || (this.state.cards.length > 0)) ? 'd-none' : 'd-flex'}`}>
            <p style={{fontFamily: "var(--font-family-sans-serif)"}}>
                There's nothing here, yet.
            </p>
          </div>
          {this.state.cards.map((row, index) => (
          <Col xs={1} key={index} style={{width: '100%', boxSizing: 'border-box'}}>
            <Card 
              id={`lead-${row.id}`}
              key={index}
              title={this.state.groupByCategory ? row.category_en : row.state}
              onClick={() => this.cardSelectionChanged(index)}
              className={`m-1 p-0 text-primary border border-2 ${(index === this.state.selectedCard) ? 'border-primary shadow-lg' : 'shadow'}`} 
            >
              <Card.Header className={`fs-6 text-white p-0 align-items-center`} style={{backgroundColor: `${pastelBackgrounds[index % 15]}`}}>
                <div className="d-flex flex-row">
                  <div className="p-2 h6 my-auto text-white text-truncate" style={{textWrap: "nowrap"}}>
                    {this.state.groupByCategory ? row.category_en : row.state}
                  </div>
                  <div className="ms-auto my-auto">
                    <Button id={`btn-${row.id}`} title="Switch to Leads" data-category={row.category_en} data-state={row.state} size="sm" className={`me-1 shadow`} style={{backgroundColor: "transparent", borderColor: "transparent"}} onClick={this.switchToList}>
                      <i className="text-white bi bi-folder-symlink"></i>
                    </Button>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className='p-1 d-flex align-content-end flex-column catalog-step4' style={{backgroundImage: `url(${this.getCategoryImageUrl(this.state.groupByCategory ? row.category_en : row.state)}), url(${this.state.categoryImagesState.data}images/default.jpg)`, backgroundSize: "cover", backgroundColor: `${pastelBackgrounds[index % 15]}22`}}>
                <Card.Text>
                  <div style={{height: "150px"}}></div>
                  <div className="mx-0 p-0 dark-glass text-white">
                    <div className="d-flex flex-row fs-6 justify-content-center" style={{backgroundColor: "rgba(0,0,0,0.5)"}}>
                      <div>{parseInt(row.Total_Leads).toLocaleString()}&nbsp;Businesses</div>
                    </div>
                    <div className="d-flex flex-row">
                      <div className="text-end me-2" style={{width: "25%"}}>{parseInt(row.Branches).toLocaleString()}</div><div style={{width: "30%"}}>Branches</div>
                      <div className="text-end me-2" style={{width: "20%"}}>{parseInt(row.Phone_Numbers).toLocaleString()}</div><div style={{width: "25%"}}>Phones</div></div>
                    <div className="d-flex flex-row">
                      <div className="text-end me-2" style={{width: "25%"}}>{parseInt(row.Addresses).toLocaleString()}</div><div style={{width: "30%"}}>Addresses</div>
                      <div className="text-end me-2" style={{width: "20%"}}>{parseInt(row.Emails).toLocaleString()}</div><div style={{width: "25%"}}>Emails</div></div>
                    <div className="d-flex flex-row">
                      <div className="text-end me-2" style={{width: "25%"}}>{parseInt(row.Websites).toLocaleString()}</div><div style={{width: "30%"}}>Websites</div>
                      <div className="text-end me-2" style={{width: "20%"}}>{parseInt(getSocialCount(row)).toLocaleString()}</div><div style={{width: "25%"}}>Social</div></div>
                    <div className="d-flex flex-row">
                      <div className="text-end me-2" style={{width: "25%"}}>{parseInt(row.contactformcount).toLocaleString()}</div><div style={{width: "30%"}}>Contact Forms</div>
                      <div className="text-end me-2" style={{width: "20%"}}>{parseInt(row.People).toLocaleString()}</div><div style={{width: "25%"}}>People</div></div>
                  </div>
                </Card.Text>
              </Card.Body>
              {/*
              <Card.Footer className="px-0 d-flex">
                <div className="mx-2 my-auto">{parseInt(row.Total_Leads * this.state.userPricing.cost).toLocaleString(this.state.userPricing.locale, { style: "currency", maximumFractionDigits: 0, currency: this.state.userPricing.currency })}</div>
                <Button 
                  className="mx-1 ms-auto rounded-pill" 
                  variant={`${this.isItemInCart(row.category_en, row.state) ? 'primary' : 'outline-primary'}`} 
                  size="sm" 
                  data-value={this.state.groupByCategory ? row.category_en : row.state} 
                  data-amount={parseInt(row.Total_Leads * this.state.userPricing.cost)}
                  onClick={this.addToCart}>
                  {this.isItemInCart(row.category_en, row.state) ? 'In Cart' : 'Add to Cart'}
                </Button>
              </Card.Footer>
              */}
            </Card>
          </Col>
            ))}
        </div>
          ) : <div></div>}
      </SplitPane>
      {/*
      <Button
        variant="primary"
        onClick={() => this.setState({showCart: !this.state.showCart})}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '30px',
          borderRadius: '50%',
          width: '48px',
          height: '48px',
          zIndex: 1050, // above most content
        }}
      >
        <i class="bi bi-cart"></i>
        {this.state.shoppingCart.length > 0 && (
          <Badge
            bg="info"
            pill
            style={{
              position: 'absolute',
              top: '5px',
              right: '5px',
              fontSize: '0.7rem',
              color: 'black'
            }}
          >
            {this.state.shoppingCart.length}
          </Badge>
        )}
      </Button>
      <Offcanvas show={this.state.showCart} onHide={() => this.setState({showCart: false})} placement="end" backdrop={false}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Your Cart</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {this.state.shoppingCart.length === 0 ? (
            <span className='fs-6'>Your cart is empty.</span>
          ) : (<>
            <div className="overflow-auto" style={{ maxHeight: '60%' }}>
              <ListGroup variant="flush">
                {this.state.shoppingCart.map((item, index) => (
                  <ListGroup.Item key={index}>
                    <Row>
                      <Col xs={1} className="my-auto"><i className={`bi ${(item.type === GROUP_BY_STATE) ? 'bi-globe-americas' : 'bi-columns-gap'}`}></i></Col>
                      <Col xs={5} className="my-auto">{item.value}</Col>
                      <Col xs={4} className="my-auto text-end">{parseFloat(item.amount).toLocaleString(this.state.userPricing.locale, { style: "currency", maximumFractionDigits: 0, currency: this.state.userPricing.currency})}</Col>
                      <Col xs={2} className="d-flex">
                        <Button size="sm" className="ms-auto rounded-pill" data-type={item.type} data-value={item.value} onClick={this.deleteFromCart}>
                          <i className="bi bi-trash"></i>
                        </Button>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            </div>
            <Row className="p-3 fw-bold">
              <Col xs={1}></Col>
              <Col xs={5}>Sub Total ({this.state.shoppingCart.length} items)</Col>
              <Col xs={4} className="text-end">{this.state.shoppingCart.reduce((sum, item) => {return sum + parseFloat(item.amount)}, 0).toLocaleString(this.state.userPricing.locale, { style: "currency", maximumFractionDigits: 0, currency: this.state.userPricing.currency})}</Col>
              <Col xs={2}></Col>
            </Row>
            <div className="mt-3 d-flex">
    `         <Button className="ms-auto" variant="primary" onClick={() => alert('Checkout')}>
                Proceed to Checkout
              </Button>
            </div>
  `       </>)}
        </Offcanvas.Body>
      </Offcanvas>
      */}
    </React.Fragment>
    )}
}

export default MCatalog;